import { look } from "../components/look";
import { obstacle } from "../components/obstacle";
import { config } from "../config";
import type { LookKey } from "../config/assetManifest";
import type { ObstacleConfig } from "../config/types";
import { k } from "../core/kaplay";
import { registerEntity } from "../core/registry";

function hitbox(cfg: ObstacleConfig) {
    const [w, h] = cfg.hitboxPx ?? [32, 16];
    return new k.Rect(k.vec2(-w / 2, -h), w, h);
}

function tagsFor(cfg: ObstacleConfig): string[] {
    const tags = ["obstacle", "world"];
    if (cfg.tall) tags.push("tall");
    if (cfg.kind === "soft") tags.push("soft");
    return tags;
}

export function registerObstacles() {
    for (const [type, cfg] of Object.entries(config.obstacles)) {
        if (cfg.kind !== "solid" && cfg.kind !== "soft") continue;
        registerEntity(type, (d) =>
            k.add([
                k.pos(d.x, d.y),
                look(type as LookKey, d.variant),
                k.area({ shape: hitbox(cfg), isSensor: true }),
                k.z(d.y),
                obstacle(type, cfg),
                ...tagsFor(cfg),
            ]),
        );
    }
}
